import { createAction, createAsyncAction } from 'typesafe-actions';
import { Credentials } from '@rootCommon/types/auth';
import Profile from '@rootCommon/types/profile';
import { ResultFailure } from '@rootCommon/types/common';

export const signInAdminPanel = createAsyncAction(
  'USER_SIGN_IN_ADMIN_PANEL_REQUEST',
  'USER_SIGN_IN_ADMIN_PANEL_SUCCESS',
  'USER_SIGN_IN_ADMIN_PANEL_FAILURE',
)<Credentials, Profile, ResultFailure>();

export const signInControlPanel = createAsyncAction(
  'USER_SIGN_IN_CONTROL_PANEL_REQUEST',
  'USER_SIGN_IN_CONTROL_PANEL_SUCCESS',
  'USER_SIGN_IN_CONTROL_PANEL_FAILURE',
)<Credentials, Profile, ResultFailure>();

export const signOutUser = createAction('USER_SIGN_OUT')<void>();
